import { createFileRoute } from "@tanstack/react-router";
import { Clock, MapPin, Phone } from "lucide-react";
import { BookingForm } from "@/components/BookingForm";
import { FadeUp } from "@/components/Motion";
import { buildMeta, buildLinks, breadcrumbSchema } from "@/lib/seo";
import { SITE } from "@/lib/site";

export const Route = createFileRoute("/agendamento")({
  head: () => ({
    meta: buildMeta({
      title: "Agendar Consulta com Podóloga em Belém do Pará | Podomasso",
      description:
        "Agende sua consulta de podologia em Belém do Pará. Preencha o formulário e confirmaremos pelo WhatsApp. Atendimento de domingo a sexta, das 9h às 20h.",
      path: "/agendamento",
    }),
    links: buildLinks("/agendamento"),
    scripts: [
      breadcrumbSchema([
        { name: "Início", path: "/" },
        { name: "Agendamento", path: "/agendamento" },
      ]),
    ],
  }),
  component: AgendamentoPage,
});

function AgendamentoPage() {
  return (
    <>
      <section className="bg-gradient-soft py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <FadeUp>
            <p className="mb-3 text-sm font-semibold uppercase tracking-wider text-primary">
              Agende Sua Consulta
            </p>
            <h1 className="font-display text-4xl font-bold leading-tight sm:text-5xl lg:text-6xl">
              Marque Seu Horário <span className="text-gradient-hero">Online</span>
            </h1>
            <p className="mt-5 max-w-2xl text-lg text-muted-foreground">
              Preencha o formulário abaixo e confirmaremos seu agendamento pelo WhatsApp.
              Atendemos de domingo a sexta, das 9h às 20h.
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="bg-background py-16 lg:py-24">
        <div className="mx-auto grid max-w-6xl gap-10 px-4 sm:px-6 lg:grid-cols-[1.4fr_1fr] lg:px-8">
          <FadeUp>
            <BookingForm />
          </FadeUp>
          <FadeUp delay={0.1}>
            <div className="space-y-5 rounded-3xl bg-secondary/40 p-7">
              <h2 className="font-display text-xl font-bold">Informações úteis</h2>
              {[
                { icon: Clock, t: "Horário", c: `${SITE.hours.days}: ${SITE.hours.open} às ${SITE.hours.close}` },
                { icon: Phone, t: "Telefone / WhatsApp", c: SITE.phoneDisplay },
                { icon: MapPin, t: "Local", c: "Belém — PA" },
              ].map((b) => (
                <div key={b.t} className="flex gap-3">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background text-primary shadow-soft">
                    <b.icon className="h-4 w-4" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold">{b.t}</p>
                    <p className="text-sm text-muted-foreground">{b.c}</p>
                  </div>
                </div>
              ))}
              <p className="rounded-xl bg-background p-4 text-xs text-muted-foreground">
                <strong className="text-foreground">Importante:</strong> O agendamento só é
                confirmado após nossa resposta pelo WhatsApp. Pacientes diabéticos têm prioridade
                em horários de manhã.
              </p>
            </div>
          </FadeUp>
        </div>
      </section>
    </>
  );
}
